import React from "react";
import { Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
function formatFields(arr) {
  return arr.map(item => {
    // If already an object, return as is
    if (typeof item === "object" && item !== null) {
      return item;
    }

    // Convert string to object
    return {
      label: item.charAt(0).toUpperCase() + item.slice(1)?.replaceAll("_", " "),
      key: item
    };
  });
}
const SearchBar = ({
  bylist = [],
  label,
  btnLabel,
  handleSearch
}) => {
  const [filterValue, setFilterValue] = React.useState("");
  const [filterField, setFilterField] = React.useState("");
  const user = useSelector((state) => state?.loginState?.auth);
  let ff = formatFields(bylist)
  let list = [{ label: "Search by", key: "" }].concat(ff)


  return (<>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 2,
        // background: "#d3d3d3",
        gap: 2,
        py: 1,
        borderRadius: 2,
      }}
    >
      <select
        value={filterField}
        onChange={(e) => setFilterField(e.target.value)}
        style={{ maxWidth: 200 }}
      >
        {list.map((b) => <option value={b?.key}>{b?.label}</option>)}
      </select>
      <input
        value={filterValue}
        onChange={(e) => setFilterValue(e.target.value)}
        placeholder="Search value"
      />
      <Box flexGrow={1} />
      <Button className="btn-primary" onClick={() => filterField !== "Search by" ? handleSearch(filterField, filterValue) : () => { }}>
        Search
      </Button>
    </Box>
  </>
  );
};

export default SearchBar;
